import { call, put, takeLatest,select } from "redux-saga/effects";
import {
  fetchSuccess,
  locationAlarmCountSuccess,
  fetchFailure,
  downloadSuccess,
  downloadFailure,
  organizationTypes,
} from "../actions/organization";
import {
  fetchOrganizationEndPoint,
  fetchSmartAlertsEndPoint,
  fetchLocationEndPoint,
} from "../../configuration";
import { getRandomUUID } from "../../Token";

import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";

function* fetchOrganizationSaga(action) {
  try {
        const limit = action.payload?.limit;
        const payload = yield select((state) => ({
        filters: state.organization.filter,
         name: state.organization.filter.name,
         createdon: state.organization.filter.createdon,
         pageNo: state?.organization?.filter?.pageNo,
         limit: limit ? limit : state.organization.filter.limit,
        }));

        function formatForSelection(date) {
            const year = date.getUTCFullYear();
            const month = String(date.getUTCMonth() + 1).padStart(2, "0");
            const day = String(date.getUTCDate()).padStart(2, "0");
            const hours = String(date.getUTCHours()).padStart(2, "0");
            const minutes = String(date.getUTCMinutes()).padStart(2, "0");
            return `${year}-${month}-${day}T${hours}:${minutes}`;
          }

        const startDate = new Date(payload?.filters.lastUpdatedfrom);
        const endDate = new Date(payload?.filters.lastUpdatedto);
        const startFormatted = formatForSelection(startDate);
        const endFormatted = formatForSelection(endDate);
        const filterData = [startFormatted, endFormatted].join("','");
        const orgResponse = yield call(fetchOrganizationAPI,payload, filterData);
      //  const locResponse = yield call(fetchLocationAPI);
        const orgs=orgResponse?.organizations;
    
    // const orgs = orgResponse?.organizations?.filter(
    //   (org) =>
    //     org.kind === "ts.tag.org" ||
    //     (org.tags && org.tags.length > 0 && org.tags[0].kind === "ts.tag.org")
    // );
    // orgs?.sort((a, b) => {
    //   if (
    //     Array.isArray(a?.tags) &&
    //     a?.tags?.length > 0 &&
    //     a?.tags[0]?.org_name &&
    //     Array.isArray(b?.tags) &&
    //     b?.tags?.length > 0 &&
    //     b?.tags[0]?.org_name
    //   ) {
    //     return a?.tags[0]?.org_name?.localeCompare(b?.tags[0]?.org_name);
    //   } else if (a?.org_name && b?.org_name) {
    //     return a?.org_name?.localeCompare(b?.org_name);
    //   }
    //   return 0;
    // });
    // const countMap = {};
    // locResponse?.locations?.forEach((siteItem) => {
    //   const orgId = siteItem.tags?.[0]?.orgId;
    //   if (orgId) {
    //     countMap[orgId] = (countMap[orgId] || 0) + 1;
    //   }
    // });
    // orgs.forEach((orgItem) => {
    //   const orgId = orgItem.id;
    //   const count = countMap[orgId] || 0;
    //   orgItem.locationcount = (orgItem.count || 0) + count;
    // });
     yield put(
          fetchSuccess({
           total: orgResponse?.totalCount || 0,
           organization: orgs,
          })
        );
  
    // yield put(fetchSuccess(orgs));
    // const alarmResponse = yield call(
    //   fetchAlarmByOrgIdAPI,
    //   orgs.map((org) => org.id)
    // );

   // let index = 0;
   // let alarms = {};
    // while (index < orgs.length) {
    //   const currentId = orgs[index].id;
    //   alarms = {
    //     ...alarms,
    //     [currentId]: {
    //       warningCount: alarmResponse.data.filter(
    //         (alarm) =>
    //           alarm.metadata.orgId === currentId && alarm.severity === "Warning"
    //       ).length,
    //       errorCount: alarmResponse.data.filter(
    //         (alarm) =>
    //           alarm.metadata.orgId === currentId &&
    //           (alarm.severity === "Error" || alarm.severity === "Critical")
    //       ).length,
    //     },
    //   };
    //   index++;
    // }

   // yield put(locationAlarmCountSuccess(alarms));
  } catch (error) {
    console.log("error", error);
    yield put(fetchFailure(error.message));
  }
}

async function fetchOrganizationAPI(payload,filterData) {
 let $sort = [{ field: "createdon", order: "desc" }];
   let fields = {};
   let $selection = "";
    if (Object.hasOwn(payload, "name") && payload.name) {
    if (payload?.name?.value) {
       $selection = `(name LIKE '${payload?.name?.value}')`;
     // fields = { ...fields, name: payload?.name?.value };
    }
    }
    if (payload?.name?.sort && payload?.filters?.updatedval?.sort===undefined) {
      $sort = [{ field: "name", order: payload?.name?.sort }];
    } else if (payload?.filters?.updatedval?.sort) {
      $sort = [{ field: "lastupdated", order: payload?.filters?.updatedval?.sort }];
    }  

  
  if (
      filterData &&
      typeof filterData === "string" &&
      !filterData.includes("NaN")
    ) {
      $selection = `(lastupdated between('${filterData}'))`;
    }
  let filter = {$sort};
   if ($selection) {
    filter = { ...filter, $selection };
  }
  if (Object.keys(fields).length > 0) {
    filter = { ...filter, fields };
  }
  if(payload?.limit !== -1){
    filter = { ...filter, $pagenumber: payload?.pageNo || 0, $limitnumber: payload?.limit || 50 };
  }
  const response = await fetch(fetchOrganizationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter,
    }),
  });
  return response.json();
}

async function fetchLocationAPI() {
  const response = await fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    }),
  });
  return response.json();
}

async function fetchAlarmByOrgIdAPI(tagIds) {
  if (!Array.isArray(tagIds)) throw new Error("tagIds must be an array");
  const filter = tagIds
    .map((tagId) => `($/metadata/orgId eq '${tagId}')`)
    .join(" OR ");
  const response = await fetch(fetchSmartAlertsEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: {
        $selection: `${filter}`,
        $sort: [{ field: "createdon", order: "desc" }],
        $limitnumber: 500,
        $pagenumber: 0,
      },
    }),
  });

  return response.json();
}

function* downloadSaga() {
  try {
    const response = yield call(apiDownload);
    // const filterKind = response?.organizations?.filter(
    //   (item) => item.tags?.[0]?.kind === "ts.tag.org"
    // );
    const filterKind = response?.organizations;
    JSONToCSVDownload(CSVFormat(filterKind), "organization_download.csv");
    yield put(downloadSuccess([...filterKind]));
  } catch (error) {
    yield put(downloadFailure(error.message));
  }
}

const CSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => ({
    id: json.id,
    createdon: json.createdon,
    lastUpdated: json.lastupdated,
    billingaccountid: json.billingaccountid,
    organizationName: json?.name || json?.org_name || json.tags[0]?.org_name,
  }));
};

async function apiDownload() {
  return fetch(fetchOrganizationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    }),
  }).then((response) => response.json());
}

export function* FetchOrganizationSaga() {
  yield takeLatest(organizationTypes.FETCH_REQUEST, fetchOrganizationSaga);
}

export function* OrganizationDownloadSaga() {
  yield takeLatest(organizationTypes.DOWNLOAD_REQUEST, downloadSaga);
}
